import apiService from "./apiService";
import AppConstants from "../appConstants";

class UserCoreService {
    getAllUserCore(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_CORE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getUserCoreDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_USER_CORE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerUserCore(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CORE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteUserCore(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_USER_CORE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_USER_CORE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new UserCoreService();
